export type Cycle = typeof CYCLE_LIST[number]

export const CYCLE_LIST = [
  { fr: "1er", en: "1st" },
  { fr: "2e", en: "2nd" },
  { fr: "3e", en: "3rd" }
] as const;

export type Tag = typeof TAGS_LIST[number]

export const TAGS_LIST = [
  {
    value: "primary_1",
    label: "Primaire 1",
    cycle: CYCLE_LIST[0]
  },
  {
    value: "primary_2",
    label: "Primaire 2",
    cycle: CYCLE_LIST[0]
  },
  {
    value: "primary_3",
    label: "Primaire 3",
    cycle: CYCLE_LIST[1]
  },
  {
    value: "primary_4",
    label: "Primaire 4",
    cycle: CYCLE_LIST[1]
  },
  {
    value: "primary_5",
    label: "Primaire 5",
    cycle: CYCLE_LIST[2]
  },
  {
    value: "primary_6",
    label: "Primaire 6",
    cycle: CYCLE_LIST[2]
  },
] as const;